<template>
  <div class="page" v-cloak>
    <!-- 导航 -->
    <van-nav-bar :border="false" left-arrow fixed title="明细详情" class="user_balance_log_nav_bar" :z-index="9999" :style="'background: #4374FF; color:#FFFFFF;'" id="nav-bar" @click-left="onClickLeft"> </van-nav-bar>

    <div class="text-row-consume">
      <div class="header">
        <p class="desc-text">{{balanceData.description}}</p>
        <p class="amount-text"> <span v-if="balanceData.dcFlag == 0">+</span> <span v-if="balanceData.dcFlag == 1">-</span> ￥{{balanceData.changeBal || 0}}</p>
      </div>

      <div class="item-text">
        <span class="title">订单编号</span>
        <span>{{balanceData.sourceId }}</span>
      </div>

      <div class="item-text" v-if="balanceData.changeTime">
        <span class="title">创建时间</span>
        <span>{{balanceData.changeTime }}</span>
      </div>
      <div class="item-text" v-if="balanceData.station_name">
        <span class="title">站点名称</span>
        <span>{{balanceData.station_name }}</span>
      </div>
      <div class="item-text" v-if="balanceData.station_address">
        <span class="title">站点地址</span>
        <span>{{balanceData.station_address }}</span>
      </div>
      <div class="item-text" v-if="balanceData.machine_name">
        <span class="title">设备名称</span>
        <span>{{balanceData.machine_name }}</span>
      </div>
      <div class="item-text" v-if="balanceData.start_time">
        <span class="title">开始时间</span>
        <span>{{balanceData.start_time }}</span>
      </div>
      <div class="item-text" v-if="balanceData.end_time">
        <span class="title">完成时间</span>
        <span>{{balanceData.end_time }}</span>
      </div>
      <div class="item-text" v-if="balanceData.type == 2">
        <span class="title">时长</span>
        <span>{{balanceData.timePoor }}</span>
      </div>

    </div>

  </div>
</template>

<script type="text/babel">
export default {
  name: "balance-log-details",
  components: {},
  props: {},
  data() {
    return {
      balanceDetailId: this.$route.query.id,
      balanceData: {}, //类型选择
      //   dcFlag 变更类型：0增加余额 1减少余额
      // type 类型 0=充值 1=充值赠送 2=洗车订单
    };
  },
  watch: {},
  created() {},
  mounted() {
    if (!this.isLogin()) return false;
    this.$toast.loading();
    this.getcofig();
  },
  methods: {
    getcofig() {
      let _this = this;
      let data = {
        id: _this.balanceDetailId, //账户变动类型
      };
      _this.$post("/api/balance_detail", data, data).then((res) => {
        console.log(res);
        this.$toast.clear();

        if (res.data.code == 0) {
          console.log(res.data.data);

          var list = res.data.data;
          console.log(list);

          _this.balanceData = res.data.data;
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.user_balance_log_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
  .van-nav-bar__right {
    .van-nav-bar__text {
      color: #fff;
    }
  }
}
</style>
<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;
}

.text-row-consume {
  width: 100%;
  display: block;
  margin: auto 0;
  // height: 357px;
  background-color: #fff;
  padding: 15px 20px;
  border-radius: 10px;
  margin: 10px 0;
  border-bottom: 1px solid #eeeeee;

  .header {
    text-align: center;
    width: 100%;

    .desc-text {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-bottom: 20px;
    }
    .amount-text {
      font-size: 23px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
    }
  }
  .item-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-top: 23px;

    .title {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
  }

  .in-text {
    color: #333333;
  }
  .out-text {
    color: #f03535;
  }
}
</style>
 